import { request } from "./api-client";
import type { PaginatedResponse, AuditLogEntry, PerplexityMetrics } from "./types";

export type { AuditLogEntry, PerplexityMetrics };

export async function getAuditLogs(params?: {
  page?: number;
  pageSize?: number;
  action?: string;
  adminId?: string;
}): Promise<PaginatedResponse<AuditLogEntry>> {
  const query = new URLSearchParams();
  if (params?.page) query.set("page", params.page.toString());
  if (params?.pageSize) query.set("pageSize", params.pageSize.toString());
  if (params?.action) query.set("action", params.action);
  if (params?.adminId) query.set("adminId", params.adminId);

  return request(`/audit-logs?${query.toString()}`);
}

export async function getSystemHealth(): Promise<{
  data: {
    status: string;
    timestamp: string;
    services: {
      database: { status: string };
      redis: { status: string; configured: boolean };
    };
  };
}> {
  return request("/system/health");
}

export async function getPerplexityMetrics(): Promise<{ data: PerplexityMetrics }> {
  return request("/perplexity/metrics");
}
